import { cva } from 'class-variance-authority';
export const imageUploadStyling = cva('relative flex flex-col items-center justify-center gap-2 border-2 border-dashed hover:bg-gray-50 group transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-400', {
    variants: {
        size: {
            sm: 'sm:size-16 p-2',
            md: 'size-24 p-4',
            lg: 'size-32 p-4',
        },
        rounding: {
            sm: 'rounded-xl',
            md: 'rounded-2xl',
            lg: 'rounded-3xl',
            xl: 'rounded-[32px]',
            full: 'rounded-full',
        },
        _error: {
            true: 'border-red-500 focus:ring-red-500',
            false: 'border-gray-100',
        },
    },
    defaultVariants: {
        size: 'md',
        rounding: 'lg',
        _error: false,
    },
});
export const imagePreviewStyling = cva('w-full h-full object-cover rounded-lg', {
    variants: {
        size: {
            sm: '',
            md: '',
            lg: '',
            xl: '',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const placeholderStyling = cva('p-4 bg-gray-50 text-gray-600 rounded-2xl group-hover:bg-indigo-400 group-hover:text-white transition-colors', {
    variants: {
        size: {
            sm: 'p-2',
            md: 'p-4',
            lg: 'p-4',
            xl: 'p-6',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const iconStyling = cva('', {
    variants: {
        size: {
            sm: 'size-4',
            md: 'size-6',
            lg: 'size-8',
            xl: 'size-10',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const removeBtnStyling = cva('rounded-lg p-1.5 bg-red-500 hover:bg-red-600 absolute bottom-0 right-0 translate-x-2 translate-y-2 z-10', {
    variants: {
        size: {
            sm: 'p-1',
            md: 'p-1.5',
            lg: 'p-2',
            xl: 'p-2.5',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const removeIconStyling = cva('text-white', {
    variants: {
        size: {
            sm: 'size-3',
            md: 'size-3.5',
            lg: 'size-4',
            xl: 'size-5',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
